import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import styles from './styles.scss'

const handleSetStateObj = (state, index, selected) => {
  const newState = [...state]
  newState[index] = { ...state[index], selected }
  return newState
}

const Chip = ({ selected, children, ...props }) => (
  <div
    className={`${styles.chips} ${selected ? styles.selected : styles.unselected}`}
    {...props}
  >
    {selected && <i className={`cred-icon icon-check-circle ${styles.icon}`} />}
    {children}
  </div>
)

Chip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  selected: PropTypes.bool,
}

const Chips = ({ values, maxSelected, minSelected, className, onSelect, ...props }) => {
  const [state, setState] = useState(values),
    selectedCount = useRef(state.filter(({ selected }) => selected).length)

  return (
    <div
      className={styles.chipsContainer}
    >
      {state.map(({ name, selected }, index) => (
        <Chip
          selected={selected}
          key={name}
          {...props}
          onClick={() => {
            let newState = [...state]

            if (maxSelected === 1) {
              newState.forEach((el, indexState) => {
                if (el.selected) newState[indexState] = { ...el, selected: false }
              })

              newState = handleSetStateObj(newState, index, true)
              selectedCount.current = 1
            } else if (!selected && selectedCount.current < maxSelected) {
              newState = handleSetStateObj(state, index, true)
              selectedCount.current++
            } else if (selectedCount.current > minSelected) {
              newState = handleSetStateObj(state, index, false)
              selectedCount.current--
            }

            setState(newState)
            onSelect(newState)
          }}
        >
          {name}
        </Chip>
      ))}
    </div>
  )
}

Chips.propTypes = {
  values: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.object,
  maxSelected: PropTypes.number,
  minSelected: PropTypes.number,
  onSelect: PropTypes.func,
}

Chips.defaultProps = {
  className: {},
  maxSelected: 1,
  minSelected: 1,
}

export { Chip }
export default Chips
